export default "__VITE_ASSET__BfrlW226__"